import * as $ from 'jquery';
import { Observable } from 'common/barrels/rx';

export function empty() {
    return $();
}

export function div(cssClass?: string) {
    return $('<div>').toggleClass(cssClass, !!cssClass);
}

export function span(cssClass?: string) {
    return $('<span>').toggleClass(cssClass, !!cssClass);
}

export function ul(cssClass?: string) {
    return $('<ul>').toggleClass(cssClass, !!cssClass);
}

export function li(cssClass?: string) {
    return $('<li>').toggleClass(cssClass, !!cssClass);
}

export function a(cssClass?: string) {
    return $('<a>').toggleClass(cssClass, !!cssClass);
}

export function label(cssClass?: string) {
    return $('<label>').toggleClass(cssClass, !!cssClass);
}

export function checkbox() {
    return $('<input type="checkbox" />');
}

export function option(value: string, text: string) {
    return $('<option />', { value: value }).text(text);
}

export function pre(cssClass?: string) {
    return $('<pre>').toggleClass(cssClass, !!cssClass);
}

export function textbox(cssClass?: string) {
    return $('<input type="text" />').toggleClass(cssClass, !!cssClass);
}

export function passwordbox(cssClass?: string) {
    return $('<input type="password" />').toggleClass(cssClass, !!cssClass);
}

export function textarea(cssClass?: string) {
    return $('<textarea />').toggleClass(cssClass, !!cssClass);
}

export function button(cssClass?: string) {
    return $('<input type="button" />').toggleClass(cssClass, !!cssClass);
}

export function file(cssClass?: string) {
    return $('<input type="file" />').toggleClass(cssClass, !!cssClass);
}

export function tile(text: string, action: () => void) {
    return div('studio-tile')
        .append(span().text(text))
        .on('click', () => action());
}

export function table(cssClass?: string) {
    return $('<table>').toggleClass(cssClass, !!cssClass);
}

export function tbody(cssClass?: string) {
    return $('<tbody>').toggleClass(cssClass, !!cssClass);
}

export function thead(cssClass?: string) {
    return $('<thead>').toggleClass(cssClass, !!cssClass);
}

export function td(cssClass?: string, content?: string | JQuery) {
    const $td = $('<td>').toggleClass(cssClass, !!cssClass);

    if (content !== undefined && content !== null)
    {
        if (typeof content === 'string')
            $td.text(content);
        else
            $td.append(content);
    }

    return $td;
}

export function th(cssClass?: string) {
    return $('<th>').toggleClass(cssClass, !!cssClass);
}

export function tr(cssClass?: string) {
    return $('<tr>').toggleClass(cssClass, !!cssClass);
}

export function hr(cssClass?: string) {
    return $('<hr>').toggleClass(cssClass, !!cssClass);
}

export function tiles(...tiles: JQuery[]) {
    return $('<div>')
        .addClass('studio-tilecontainer')
        .append(tiles)
        ;
}

export function sidebar(...items: JQuery[]) {
    return $('<div>').append(items).addClass('studio-sidebar');
}

export function icon(iconName?: string, title?: string, cssClass?: string) {
    return $('<i>')
        .conditionalAttr(!!title, 'title', title)
        .toggleClass(cssClass, !!cssClass)
        .addClass('fa')
        .conditionalClass(!!iconName, `fa-${iconName}`)
        ;
}

export function img(cssClass?: string): JQuery {
    return $('<img>').toggleClass(cssClass, !!cssClass);
}

export function redrawRequired(trigger: Observable<any>, gate: Observable<boolean>): Observable<any> {
    return trigger.combineLatest(gate, (x, y) => y).filter(x => x);
}

export function windowResized(gate?: Observable<boolean>, fireImmediately: boolean = false) {
    const resize = Observable.fromEvent($(window), 'resize');

    const trigger = fireImmediately ? Observable.of(null).merge(resize) : resize;

    return gate
        ? redrawRequired(trigger, gate)
        : trigger;
}

export function dialog(content: (close: () => void) => JQuery, $parent?: JQuery): JQuery {
    const $dialog = div('studio-dialog');

    const close = () => $dialog.remove();

    $dialog
        .append(div('studio-dialog-mask'))
        .append(div('studio-dialog-contentcontainer').append(content(close)))
        .appendTo($parent ? $parent : $('body'));

    return $dialog;
}

export function field(text: string, ...content: JQuery[]): JQuery {
    return div('studio-field').append([
        span('studio-field-label').text(text),
        ...content
    ]);
}

export function form() {
    return $('<form></form>')
}

export function hidden(name: string, value: string) {
    return $('<input type="hidden" />').attr('name', name).attr('value', value);
}

export function iframe(cssClass?: string) {
    return $('<iframe></iframe>').toggleClass(cssClass, !!cssClass);
}